<template>
    <div :class="'relative-form ' + (error ? ' error-class-select' : '') + (multiple ? ' multiple-suggestion' : '')">
        <label v-if="label">{{label}}:</label>
        <vue-simple-suggest
                pattern="\w+"
                v-model="selecao"
                :list="getData"
                mode="select"                
                :min-length="0"
                :max-suggestions="0"
                :display-attribute="options.text"
                :value-attribute="options.value"
                :debounce="1000"
                @select="emit"
                :filter-by-query="false"
                ref="suggest">

            <div class="g">
                <input type="text" :class="classe" ref="input" :placeholder="placeholderAt ? placeholderAt : placeholder">

                <div class="multiple-suggestion-btn-groups" v-if="multiple">
                    <button class="btn-verde" type="button" @click.prevent="submitSelectedSuggestions">Inserir {{ checks.length }} itens selecionados</button>
                    <button class="btn-red" type="button" @click.prevent="clearSelectedSuggestions">Limpar {{ checks.length }} itens selecionados</button>
                </div>
            </div>

            <template slot="misc-item-above" slot-scope="{ suggestions }">
                <div class="misc-item">
                    <span>{{ textSearchBy }}</span>
                    
                    <span style="color: red; float: right; cursor: pointer">
                        <button class="btn btn-primary" @click.prevent="hideList">
                            Fechar
                            <i class="fa fa-close"></i>
                        </button>
                    </span>
                </div>

                <template v-if="suggestions.length > 0">
                    <div class="misc-item">
                        <span>{{ suggestions.length }} sugestões exibidas...</span>
                    </div>
                    <hr>
                </template>

                <div class="misc-item" v-else-if="!loading && showMessagenoResultsFound">
                    <span>Nenhuma correspondência</span>
                </div>
            </template>

            <label class="multiple-suggestion-item" slot-scope="{ suggestion }" slot="suggestion-item" @click.stop="stopSuggestionClick" v-if="multiple">
                <input type="checkbox" :disabled="isDisable(suggestion[options.value])"  :value="suggestion[options.value]" v-model="checks">
            
                <div class="text">
                    <span v-html="suggestion[options.text]"></span>
                </div>                            
            </label>

            <div class="misc-item vue-suggest-loading" slot="misc-item-below" v-if="loading">
                <vue-element-loading :active="true" spinner="bar-fade-scale"/>
            </div>
        </vue-simple-suggest>
    </div>
</template>

<script>
    import 'vue-simple-suggest/dist/styles.css';

    export default {
        data() {
            return {
                selecao: null,
                data: Array,
                loading: false,
                placeholderAt: '',
                checks: [],
                textSearchBy: '',
                showMessagenoResultsFound: false,
                ignoreWatchOrder: false
            }
        },
        props: {
            label:       String,
            url:         String,
            options:     Object,
            placeholder: String,
            error:       Boolean,
            classe:      String,
            manipulate:  { type: Function },
            arg:         String,
            arg2:        String,
            arg3:        String,
            arg4:        String,
            multiple:    Boolean,
            limitItems:  Number,
            itemsAlreadySelected: Array
        },
        watch: {
            checks(newValue) 
            {
                if (!this.ignoreWatchOrder) {
                    this.checkLimitItems(newValue)
                }

                if (this.itemsAlreadySelected.length === this.limitItems) {
                    this.handleToasted(`Você atingiu o limite de ${this.limitItems} itens selecionados.`)
                }

                if (((this.checks.length + this.itemsAlreadySelected.length) === this.limitItems)) {
                    this.handleToasted(`Você atingiu o limite de ${this.limitItems} itens selecionados.`)
                }

                this.$nextTick(() => {
                    this.ignoreWatchOrder = true
                });
            },
        },        
        methods: {            
            isDisable(value)
            {      
                if (!this.limitItems) {
                    return false
                }
                            
                if (this.itemsAlreadySelected.length === this.limitItems) {
                    return true
                }
            
                if (((this.checks.length + this.itemsAlreadySelected.length) === this.limitItems) && !this.checks.includes(value)) {
                    return true
                }

                if (this.limitItems && !this.checks.includes(value)) {                    
                    return this.checks.length === this.limitItems
                }
            },
            submitSelectedSuggestions()
            {         
                if (!this.checkLimitItems(this.checks)) {
                    return false
                }
                
                this.$emit('changeData', this.checks);
            },
            handleToasted(message)
            {
                this.$toasted.show(message, {
                    type: "error",
                    duration: 4000
                });
            },
            checkLimitItems(checks) 
            {
                if (!this.limitItems) {
                    return true
                }

                if ((checks.length > this.limitItems) || (this.itemsAlreadySelected.length === this.limitItems)) {
                    this.handleToasted(`Você pode adicionar no máximo ${this.limitItems} itens.`)
                                    
                    return false
                }

                return true
            },
            clearSelectedSuggestions()
            {
                this.ignoreWatchOrder = true
                this.checks = []
            },
            stopSuggestionClick(event)
            {
                event.stopPropagation() 
            },            
            emit()
            {
                if (this.selecao)
                {
                    this.$emit('changeData', this.selecao);
                }
            },
            getData(value)
            {
                if (value.length < 3) {
                    this.textSearchBy = 'Digite no mínimo 3 caracteres';
                    this.showMessagenoResultsFound = false;
                    return false;
                }

                this.textSearchBy = `Procurando por: '${value}'.`;
                this.showMessagenoResultsFound = true;

                this.$refs.suggest.clearSuggestions();
                this.loading = true;

                const params = { term: value, arg: this.arg, arg2: this.arg2 };

                if (this.arg3) {
                    params.arg3 = this.arg3
                }

                if (this.arg4) {
                  params.arg4 = this.arg4
                }

                return new Promise((resolve) => {
                    this.axios.get(_ROOT_PATH + this.url, {params: params}).then((result) => {

                        if (result.data.records instanceof Object)
                        {
                            result.data.records = Object.values(result.data.records);
                        }

                        if (this.manipulate)
                        {
                            resolve(this.manipulate(result));
                        }
                        else
                        {
                            resolve(result);
                        }

                        this.loading = false;
                    })
                })
            },
            clearInput()
            {
                if (this.selecao && this.multiple)
                {
                    const el = document.getElementsByClassName('input-field-post')[0];

                    if (el)
                    {
                        el.value = '';
                    }

                    this.$refs.suggest.text = '';
                    this.placeholderAt = this.selecao.descricao;
                }
            },
            hideList()
            {              
                this.$refs.suggest.hideList();
            },
            handleScrollClick(event) {
                if (event.target.classList.contains('suggestions')) {
                    event.preventDefault();
                }
            },
        },
        updated()
        {
            this.clearInput()
        },
        mounted()
        {
            // Esse trecho foi aplicado para evitar que a lista feche ao clicar no scrollbar
            const selectProductList = this.$refs.suggest?.$el
            if(selectProductList) {
                selectProductList.addEventListener('mousedown', this.handleScrollClick);
            }
        },
        beforeDestroy() {
            const selectProductList = this.$refs.suggest?.$el
            if(selectProductList) {
                selectProductList.removeEventListener('mousedown', this.handleScrollClick);
            }
        },
    };
</script>